import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'Lucas G.',
  city: 'Buenos Aires',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 2 min'
}, {
  name: 'Martín R.',
  city: 'Córdoba',
  product: 'MegaPack Detailer Argentino',
  time: 'hace 5 min'
}, {
  name: 'Federico A.',
  city: 'Rosario',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 8 min'
}, {
  name: 'Joaquín P.',
  city: 'Mendoza',
  product: 'MegaPack Detailer Argentino',
  time: 'hace 12 min'
}, {
  name: 'Nicolás C.',
  city: 'Tucumán',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 15 min'
}, {
  name: 'Pablo R.',
  city: 'Santa Fe',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 18 min'
}, {
  name: 'Agustín G.',
  city: 'Salta',
  product: 'MegaPack Detailer Argentino',
  time: 'hace 22 min'
}, {
  name: 'Sebastián M.',
  city: 'La Plata',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 25 min'
}, {
  name: 'Diego F.',
  city: 'Mar del Plata',
  product: 'MegaPack Detailer Argentino',
  time: 'hace 30 min'
}, {
  name: 'Tomás B.',
  city: 'Neuquén',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 35 min'
}, {
  name: 'Ramiro G.',
  city: 'San Juan',
  product: 'MegaPack Detailer Argentino',
  time: 'hace 40 min'
}, {
  name: 'Andrés V.',
  city: 'Paraná',
  product: 'MegaPack + El Método Cerámico™',
  time: 'hace 45 min'
}];
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    const initialTimeout = setTimeout(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 6000);
    const interval = setInterval(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 12000 + Math.random() * 6000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  return <div className="fixed bottom-4 left-4 z-50" style={{
    maxWidth: 'calc(100vw - 32px)'
  }} data-id="element-271">
      <AnimatePresence data-id="element-272">
        {visible && purchase && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="flex items-center gap-3 border border-yellow-400/40 rounded-xl px-4 py-3 shadow-lg max-w-sm" style={{
        backgroundColor: '#ffffff',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }} data-id="element-273">
            {/* Avatar */}
            <div className="flex h-9 w-9 shrink-0 items-center justify-center bg-yellow-400/10 text-yellow-500 rounded-full text-sm font-black" data-id="element-274">
              🚗
            </div>

            {/* Info */}
            <div className="min-w-0 flex-1" data-id="element-275">
              <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-276">
                {purchase.name} de {purchase.city}
              </p>
              <p className="text-[10px] text-gray-500 m-0 truncate" data-id="element-277">
                compró el{' '}
                <span className="font-semibold text-yellow-500" data-id="element-278">
                  {purchase.product}
                </span>
              </p>
              <p className="text-[9px] text-gray-400 m-0 mt-0.5" data-id="element-279">
                🕐 {purchase.time}
              </p>
            </div>

            {/* Verified badge */}
            <div className="shrink-0" data-id="element-280">
              <span className="text-[9px] font-bold text-green-600 bg-green-50 border border-green-200 rounded-full px-1.5 py-0.5" data-id="element-281">
                ✓ Verificado
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}